(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const body = document.body;
  const open = (el) => { if(!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); body.classList.add('drawer-open'); };
  const close = (el) => { if(!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); body.classList.remove('drawer-open'); };
  const mobile = $('[data-mobile-menu]');
  $('[data-menu-open]')?.addEventListener('click', () => open(mobile));
  $('[data-menu-close]')?.addEventListener('click', () => close(mobile));
  const cartDrawer = $('[data-cart-drawer]'); const overlay = $('[data-cart-overlay]');
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', () => { open(cartDrawer); overlay.hidden=false; }));
  const closeCart = () => { close(cartDrawer); if(overlay) overlay.hidden=true; };
  $('[data-cart-close]')?.addEventListener('click', closeCart); overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if(e.key==='Escape'){ closeCart(); close(mobile); } });
  $$('[data-qty-plus]').forEach(b => b.addEventListener('click', () => { const i=b.parentElement.querySelector('input'); i.stepUp(); }));
  $$('[data-qty-minus]').forEach(b => b.addEventListener('click', () => { const i=b.parentElement.querySelector('input'); i.stepDown(); }));
  async function addToCart(form, options = {}){
    const { openDrawer = true } = options;
    const data = new FormData(form);

    // return_to is only for normal browser form submissions.
    // We are posting to /cart/add.js, so remove it from the AJAX payload.
    data.delete('return_to');

    const res = await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Accept':'application/json'},
      body:data
    });

    if(!res.ok) throw new Error((await res.json()).description || 'Erro ao adicionar');

    const cart = await fetch('/cart.js').then(r=>r.json());
    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);

    if(openDrawer && cartDrawer){
      open(cartDrawer);
      if(overlay) overlay.hidden=false;
      const content = $('[data-cart-content]');
      const total = $('[data-cart-total]');
      if(content) content.innerHTML='<p>Produto adicionado à sacola.</p>';
      if(total) total.textContent=(cart.total_price/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
    }

    return cart;
  }

  $$('[data-quick-add], [data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      const submitter = e.submitter || document.activeElement;
      const isBuyNow = !!submitter?.closest?.('[data-buy-now]');
      const button = submitter?.matches?.('button') ? submitter : form.querySelector('button[type="submit"]');

      button?.setAttribute('aria-busy','true');
      if(button) button.disabled = true;

      try{
        await addToCart(form, { openDrawer: !isBuyNow });

        if(isBuyNow){
          const returnInput = form.querySelector('[data-buy-now-return]');
          const loggedIn = returnInput?.dataset.customerLoggedIn === 'true';

          if(loggedIn){
            window.location.assign('/account/login?return_url=%2Fcheckout');
          }else{
            window.location.assign('/account/login?return_url=%2Fcheckout');
          }
        }
      }catch(err){
        alert(err.message);
      }finally{
        button?.removeAttribute('aria-busy');
        if(button) button.disabled = false;
      }
    });
  });
  const root = $('[data-product-root]');
  if(root){ const variants=JSON.parse($('[data-product-json]',root)?.textContent || '[]'); const radios=$$('input[type="radio"]',root); const select=$('select[name="id"]',root); const update=()=>{ const chosen={}; radios.filter(r=>r.checked).forEach(r=>chosen[r.name.replace('options[','').replace(']','')]=r.value); const variant=variants.find(v=>v.options.every((val,i)=>val===Object.values(chosen)[i])); if(variant&&select){ select.value=variant.id; const btn=$('.add-to-cart',root); btn.disabled=!variant.available; $('[data-add-label]',root).textContent=variant.available?'Adicionar ao carrinho':'Esgotado'; } }; radios.forEach(r=>r.addEventListener('change',update)); }
})();

/* Animated store intro: always show on homepage */
document.addEventListener('DOMContentLoaded', () => {
  const intro = document.querySelector('[data-site-intro]');
  if (!intro) return;

  const duration = Number.parseInt(intro.dataset.introDuration || '1700', 10);
  const fadeDuration = Number.parseInt(intro.dataset.introFadeDuration || '900', 10);

  intro.style.setProperty('--intro-fade-duration', `${fadeDuration}ms`);
  document.body.style.setProperty('--intro-fade-duration', `${fadeDuration}ms`);
  document.body.classList.add('has-site-intro');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => intro.classList.add('is-ready'));
  });

  window.setTimeout(() => {
    document.body.classList.remove('has-site-intro');
    document.body.classList.add('site-intro-revealing');
    intro.classList.add('is-leaving');

    window.setTimeout(() => {
      intro.remove();
      document.body.classList.remove('site-intro-revealing');
    }, fadeDuration + 120);
  }, duration);
});

/* Configurable promotion popup */
(() => {
  const popup = document.querySelector('[data-promotion-popup]');
  if (!popup) return;

  const storageKey = 'outmoon-promotion-popup';
  const frequency = popup.dataset.frequency || 'session';
  const delay = Number.parseInt(popup.dataset.delay || '3000', 10);
  const closeButtons = popup.querySelectorAll('[data-promotion-close]');
  const action = popup.querySelector('[data-promotion-action]');
  const couponButton = popup.querySelector('[data-copy-coupon]');
  let previousFocus = null;

  const hasBeenSeen = () => {
    try {
      if (frequency === 'always') return false;
      if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
      if (frequency === 'day') {
        const saved = Number(localStorage.getItem(storageKey) || 0);
        return saved && Date.now() - saved < 86400000;
      }
      if (frequency === 'week') {
        const saved = Number(localStorage.getItem(storageKey) || 0);
        return saved && Date.now() - saved < 604800000;
      }
    } catch (error) {}
    return false;
  };

  const markSeen = () => {
    try {
      if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
      if (frequency === 'day' || frequency === 'week') localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {}
  };

  const openPopup = () => {
    if (hasBeenSeen()) return;
    previousFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('promotion-popup-open');
    popup.querySelector('.promotion-popup__close')?.focus();
  };

  const closePopup = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('promotion-popup-open');
    markSeen();
    previousFocus?.focus?.();
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  action?.addEventListener('click', markSeen);

  couponButton?.addEventListener('click', async () => {
    const code = couponButton.dataset.copyCoupon;
    const feedback = couponButton.querySelector('[data-coupon-feedback]');
    try {
      await navigator.clipboard.writeText(code);
      if (feedback) feedback.textContent = 'Cupom copiado';
    } catch (error) {
      if (feedback) feedback.textContent = `Use: ${code}`;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  if (!hasBeenSeen()) window.setTimeout(openPopup, Math.max(0, delay));
})();

/* Brazilian customer profile: CPF, phone and ViaCEP autofill */
(() => {
  const form = document.querySelector('[data-address-form]');
  if (!form) return;
  const $ = (selector) => form.querySelector(selector);
  const onlyDigits = (value) => String(value || '').replace(/\D/g, '');
  const cpf = $('[data-cpf-input]');
  const cpfStatus = $('[data-cpf-status]');
  const phone = $('[data-phone-input]');
  const whatsapp = $('[data-whatsapp-input]');
  const cep = $('[data-cep-input]');
  const cepStatus = $('[data-cep-status]');
  const street = $('[data-street-input]');
  const number = $('[data-number-input]');
  const complement = $('[data-complement-input]');
  const neighborhood = $('[data-neighborhood-input]');
  const city = $('[data-city-input]');
  const state = $('[data-state-input]');
  const companyMeta = $('[data-company-meta]');

  const validateCpf = (value) => {
    const digits = onlyDigits(value);
    if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) return false;
    const calc = (length) => {
      let sum = 0;
      for (let i = 0; i < length; i++) sum += Number(digits[i]) * (length + 1 - i);
      const result = (sum * 10) % 11;
      return result === 10 ? 0 : result;
    };
    return calc(9) === Number(digits[9]) && calc(10) === Number(digits[10]);
  };

  cpf?.addEventListener('input', () => {
    const d = onlyDigits(cpf.value).slice(0,11);
    cpf.value = d.replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2');
  });
  cpf?.addEventListener('blur', () => {
    const valid = validateCpf(cpf.value);
    cpfStatus.textContent = valid ? 'CPF válido.' : 'Confira o CPF informado.';
    cpfStatus.className = valid ? 'is-success' : 'is-error';
    cpf.setCustomValidity(valid ? '' : 'CPF inválido');
  });

  phone?.addEventListener('input', () => {
    const d = onlyDigits(phone.value).slice(0,11);
    phone.value = d.length > 10 ? d.replace(/(\d{2})(\d{5})(\d{4})/,'($1) $2-$3') : d.replace(/(\d{2})(\d{4})(\d{0,4})/,'($1) $2-$3');
  });

  let lastCep = '';
  const lookupCep = async () => {
    const value = onlyDigits(cep.value);
    if (value.length !== 8 || value === lastCep) return;
    lastCep = value;
    cepStatus.textContent = 'Buscando endereço...';
    cepStatus.className = '';
    try {
      const response = await fetch(`https://viacep.com.br/ws/${value}/json/`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Falha na busca');
      const data = await response.json();
      if (data.erro) throw new Error('CEP não encontrado');
      street.value = data.logradouro || '';
      neighborhood.value = data.bairro || '';
      city.value = data.localidade || '';
      state.value = data.uf || '';
      cepStatus.textContent = 'Endereço encontrado. Complete o número.';
      cepStatus.className = 'is-success';
      number.focus();
    } catch (error) {
      cepStatus.textContent = 'CEP não encontrado. Preencha o endereço manualmente.';
      cepStatus.className = 'is-error';
      street.removeAttribute('readonly');
      neighborhood.removeAttribute('readonly');
      city.removeAttribute('readonly');
      state.removeAttribute('readonly');
    }
  };
  cep?.addEventListener('input', () => {
    const d = onlyDigits(cep.value).slice(0,8);
    cep.value = d.replace(/(\d{5})(\d)/,'$1-$2');
    if (d.length === 8) lookupCep();
  });
  cep?.addEventListener('blur', lookupCep);

  form.addEventListener('submit', (event) => {
    if (!validateCpf(cpf.value)) {
      event.preventDefault();
      cpf.focus();
      cpf.setCustomValidity('CPF inválido');
      cpf.reportValidity();
      return;
    }
    street.value = `${street.value}, ${number.value}`.trim();
    companyMeta.value = `CPF: ${cpf.value} | WhatsApp: ${whatsapp.checked ? 'Sim' : 'Não'}`;
    try {
      localStorage.setItem('outmoon-customer-profile', JSON.stringify({ cpf: cpf.value, whatsapp: whatsapp.checked }));
    } catch (error) {}
  });
})();

/* Premium product experience */
(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const money = (cents) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format((Number(cents) || 0) / 100);
  const galleryItems = [...root.querySelectorAll('[data-gallery-item]')];
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const galleryViewport = root.querySelector('[data-gallery-viewport]');
  const moreButton = root.querySelector('[data-gallery-more]');
  const lightbox = root.querySelector('[data-product-lightbox]');
  const lightboxImage = root.querySelector('[data-lightbox-image]');
  const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
  const optionGroups = [...root.querySelectorAll('.variant-group')];
  const variantSelect = root.querySelector('[data-variant-select]');
  const productForm = root.querySelector('[data-product-form]');
  const addButton = root.querySelector('.add-to-cart');
  const addLabel = root.querySelector('[data-add-label]');
  const mobileAdd = root.querySelector('[data-mobile-add]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const currentPrice = root.querySelector('.product-price-current');
  const comparePrice = root.querySelector('.product-price-row s');
  const stockMessage = root.querySelector('[data-stock-message]');

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    const target = document.getElementById(thumb.dataset.target);
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
  }));

  if ('IntersectionObserver' in window && galleryItems.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const active = thumbs.find((thumb) => thumb.dataset.target === entry.target.id);
        if (active) thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === active));
      });
    }, { rootMargin: '-35% 0px -55%', threshold: 0.01 });
    galleryItems.forEach((item) => observer.observe(item));
  }

  moreButton?.addEventListener('click', () => {
    root.querySelectorAll('.product-gallery__item--hidden').forEach((item) => item.classList.remove('product-gallery__item--hidden'));
    moreButton.remove();
  });

  root.querySelectorAll('[data-product-zoom]').forEach((button) => button.addEventListener('click', () => {
    const image = button.querySelector('img');
    if (!image || !lightbox || !lightboxImage) return;
    lightboxImage.src = image.currentSrc || image.src;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }));
  root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => {
    lightbox.hidden = true;
    document.body.style.overflow = '';
  });
  lightbox?.addEventListener('click', (event) => {
    if (event.target !== lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  });

  const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value);
  const updateVariant = () => {
    optionGroups.forEach((group) => {
      const checked = group.querySelector('[data-option-value]:checked');
      const label = group.querySelector('[data-option-selected]');
      if (checked && label) label.textContent = checked.value;
    });
    const selected = selectedOptions();
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    if (!variant || !variantSelect) return;
    variantSelect.value = variant.id;
    if (currentPrice) currentPrice.textContent = money(variant.price);
    if (mobilePrice) mobilePrice.textContent = money(variant.price);
    if (comparePrice) {
      comparePrice.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      comparePrice.hidden = !(variant.compare_at_price > variant.price);
    }
    const available = Boolean(variant.available);
    if (addButton) addButton.disabled = !available;
    if (mobileAdd) mobileAdd.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Adicionar à sacola' : 'Avise-me quando chegar';
    if (mobileAdd) mobileAdd.textContent = available ? 'Comprar' : 'Esgotado';
    if (stockMessage) {
      stockMessage.className = 'product-stock';
      if (!available) {
        stockMessage.textContent = 'Produto indisponível';
        stockMessage.classList.add('product-stock--sold');
      } else if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
        stockMessage.textContent = `Últimas ${variant.inventory_quantity} unidades disponíveis`;
        stockMessage.classList.add('product-stock--low');
      } else {
        stockMessage.textContent = 'Produto disponível';
      }
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  root.querySelectorAll('[data-option-value]').forEach((input) => input.addEventListener('change', updateVariant));

  mobileAdd?.addEventListener('click', () => {
    if (!productForm) return;
    if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit(addButton);
    else addButton?.click();
  });

  const wishlistButton = root.querySelector('[data-wishlist-button]');
  if (wishlistButton) {
    const handle = wishlistButton.dataset.productHandle;
    let wishlist = [];
    try { wishlist = JSON.parse(localStorage.getItem('venzani-wishlist') || '[]'); } catch (error) {}
    const paint = () => {
      const saved = wishlist.includes(handle);
      wishlistButton.classList.toggle('is-saved', saved);
      wishlistButton.textContent = saved ? '♥ Salvo na lista de desejos' : '♡ Adicionar à lista de desejos';
    };
    paint();
    wishlistButton.addEventListener('click', () => {
      wishlist = wishlist.includes(handle) ? wishlist.filter((item) => item !== handle) : [...wishlist, handle];
      try { localStorage.setItem('venzani-wishlist', JSON.stringify(wishlist)); } catch (error) {}
      paint();
    });
  }

  const cepInput = root.querySelector('[data-shipping-cep]');
  const cepButton = root.querySelector('[data-shipping-submit]');
  const cepResult = root.querySelector('[data-shipping-result]');
  cepInput?.addEventListener('input', () => {
    const digits = cepInput.value.replace(/\D/g, '').slice(0, 8);
    cepInput.value = digits.replace(/(\d{5})(\d)/, '$1-$2');
  });
  cepButton?.addEventListener('click', async () => {
    const cep = cepInput.value.replace(/\D/g, '');
    if (cep.length !== 8) { cepResult.textContent = 'Digite um CEP válido com 8 números.'; return; }
    cepResult.textContent = 'Consultando CEP...';
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const address = await response.json();
      if (!response.ok || address.erro) throw new Error();
      cepResult.textContent = `${address.localidade}/${address.uf}. O prazo e o valor final serão mostrados no checkout.`;
    } catch (error) {
      cepResult.textContent = 'Não foi possível consultar o CEP. O frete será calculado no checkout.';
    }
  });
})();

/* V16 interactive editorial modules */
(() => {
  document.querySelectorAll('[data-look-target]').forEach((pin) => pin.addEventListener('click', () => {
    const card = document.getElementById(pin.dataset.lookTarget);
    if (!card) return;
    document.querySelectorAll('.shop-look__card.is-highlighted').forEach((item) => item.classList.remove('is-highlighted'));
    card.classList.add('is-highlighted');
    card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    window.setTimeout(() => card.classList.remove('is-highlighted'), 1800);
  }));
  const modal = document.querySelector('[data-size-guide]');
  const open = document.querySelector('[data-size-guide-open]');
  const close = () => { if (!modal) return; modal.hidden = true; document.body.style.overflow = ''; };
  open?.addEventListener('click', () => { modal.hidden = false; document.body.style.overflow = 'hidden'; });
  modal?.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal && !modal.hidden) close(); });
})();

/* V19: complete registration, CPF validation, CEP lookup and profile handoff */
(() => {
  const form = document.querySelector('[data-complete-register]');
  const digits = (value) => String(value || '').replace(/\D/g, '');
  const validateCpf = (value) => {
    const cpf = digits(value);
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    const check = (length) => {
      let sum = 0;
      for (let i = 0; i < length; i++) sum += Number(cpf[i]) * (length + 1 - i);
      const result = (sum * 10) % 11;
      return (result === 10 ? 0 : result);
    };
    return check(9) === Number(cpf[9]) && check(10) === Number(cpf[10]);
  };

  if (form) {
    const cpf = form.querySelector('[data-register-cpf]');
    const cpfStatus = form.querySelector('[data-register-cpf-status]');
    const phone = form.querySelector('[data-register-phone]');
    const zip = form.querySelector('[data-register-zip]');
    const zipStatus = form.querySelector('[data-register-zip-status]');
    const fields = {
      firstName: form.querySelector('#RegisterFirstName'), lastName: form.querySelector('#RegisterLastName'),
      email: form.querySelector('#RegisterEmail'), phone, cpf, zip,
      street: form.querySelector('[data-register-street]'), number: form.querySelector('[data-register-number]'),
      complement: form.querySelector('[data-register-complement]'), neighborhood: form.querySelector('[data-register-neighborhood]'),
      city: form.querySelector('[data-register-city]'), state: form.querySelector('[data-register-state]')
    };

    cpf?.addEventListener('input', () => {
      const value = digits(cpf.value).slice(0, 11);
      cpf.value = value.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    });
    cpf?.addEventListener('blur', () => {
      const valid = validateCpf(cpf.value);
      cpf.setCustomValidity(valid ? '' : 'Informe um CPF válido.');
      if (cpfStatus) { cpfStatus.textContent = valid ? 'CPF válido.' : 'Confira o CPF informado.'; cpfStatus.className = valid ? 'is-success' : 'is-error'; }
    });
    phone?.addEventListener('input', () => {
      const value = digits(phone.value).slice(0, 11);
      phone.value = value.length > 10 ? value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
    });
    const lookup = async () => {
      const value = digits(zip?.value);
      if (value.length !== 8) return;
      if (zipStatus) zipStatus.textContent = 'Buscando endereço...';
      try {
        const response = await fetch(`https://viacep.com.br/ws/${value}/json/`);
        const data = await response.json();
        if (data.erro) throw new Error();
        fields.street.value = data.logradouro || '';
        fields.neighborhood.value = data.bairro || '';
        fields.city.value = data.localidade || '';
        fields.state.value = data.uf || '';
        if (zipStatus) { zipStatus.textContent = 'Endereço encontrado. Complete o número.'; zipStatus.className = 'is-success'; }
        fields.number.focus();
      } catch (error) {
        if (zipStatus) { zipStatus.textContent = 'CEP não encontrado. Preencha manualmente.'; zipStatus.className = 'is-error'; }
      }
    };
    zip?.addEventListener('input', () => {
      const value = digits(zip.value).slice(0, 8);
      zip.value = value.replace(/(\d{5})(\d)/, '$1-$2');
      if (value.length === 8) lookup();
    });

    form.addEventListener('submit', (event) => {
      if (!validateCpf(cpf.value)) {
        event.preventDefault(); cpf.setCustomValidity('Informe um CPF válido.'); cpf.reportValidity(); return;
      }
      if (digits(phone.value).length < 10) {
        event.preventDefault(); phone.setCustomValidity('Informe um telefone válido com DDD.'); phone.reportValidity(); return;
      }
      phone.setCustomValidity('');
      const profile = Object.fromEntries(Object.entries(fields).map(([key, input]) => [key, input?.value || '']));
      try { sessionStorage.setItem('venzani_pending_profile', JSON.stringify(profile)); } catch (error) {}
    });
  }

  const addressForm = document.querySelector('[data-address-form]');
  if (addressForm) {
    let profile = null;
    try { profile = JSON.parse(sessionStorage.getItem('venzani_pending_profile') || 'null'); } catch (error) {}
    if (profile) {
      const set = (selector, value) => { const input = addressForm.querySelector(selector); if (input && value) input.value = value; };
      set('#AddressFirstNameNew', profile.firstName); set('#AddressLastNameNew', profile.lastName);
      set('[data-cpf-input]', profile.cpf); set('[data-phone-input]', profile.phone);
      set('[data-cep-input]', profile.zip); set('[data-street-input]', profile.street);
      set('[data-number-input]', profile.number); set('[data-complement-input]', profile.complement);
      set('[data-neighborhood-input]', profile.neighborhood); set('[data-city-input]', profile.city); set('[data-state-input]', profile.state);
      addressForm.insertAdjacentHTML('afterbegin', '<div class="form-success">Conta criada. Confirme e salve seu endereço para concluir o cadastro.</div>');
      addressForm.addEventListener('submit', () => { try { sessionStorage.removeItem('venzani_pending_profile'); } catch (error) {} }, { once: true });
    }
  }
})();


// Venzani Premium: solid header after scrolling
(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const update = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  update();
  window.addEventListener('scroll', update, { passive: true });
})();

/* Venzani 2.7 — hero slider */
(() => {
  const initHeroSlider = (root) => {
    if (!root || root.dataset.sliderReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-slider-slide]')];
    if (slides.length < 2) return;
    root.dataset.sliderReady = 'true';

    const track = root.querySelector('[data-slider-track]');
    const prev = root.querySelector('[data-slider-prev]');
    const next = root.querySelector('[data-slider-next]');
    const dots = [...root.querySelectorAll('[data-slider-dot]')];
    const autoplay = root.dataset.autoplay === 'true';
    const pauseHover = root.dataset.pauseHover === 'true';
    const delay = Math.max(2000, Number(root.dataset.delay) || 5000);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;
    let startX = 0;
    let deltaX = 0;

    const videos = () => slides.flatMap(slide => [...slide.querySelectorAll('video')]);

    const show = (newIndex, userInitiated = false) => {
      index = (newIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('video').forEach(video => {
          if (active) video.play().catch(() => {}); else video.pause();
        });
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (userInitiated) restart();
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      if (!autoplay || reduceMotion || document.hidden) return;
      stop();
      timer = setInterval(() => show(index + 1), delay);
    };
    const restart = () => { stop(); start(); };

    prev?.addEventListener('click', () => show(index - 1, true));
    next?.addEventListener('click', () => show(index + 1, true));
    dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.sliderDot), true)));

    if (pauseHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }

    root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; deltaX = 0; stop(); }, { passive: true });
    root.addEventListener('touchmove', (e) => { deltaX = e.touches[0].clientX - startX; }, { passive: true });
    root.addEventListener('touchend', () => {
      if (Math.abs(deltaX) > 45) show(index + (deltaX < 0 ? 1 : -1));
      start();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

/* Venzani wishlist */
(function(){
 const KEY='venzaniWishlist';
 const get=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};
 const set=a=>{localStorage.setItem(KEY,JSON.stringify(a));sync()};
 function sync(){
   const a=get(), handles=new Set(a.map(x=>x.handle));
   document.querySelectorAll('[data-wishlist-toggle]').forEach(b=>{b.classList.toggle('is-saved',handles.has(b.dataset.productHandle));b.setAttribute('aria-label',handles.has(b.dataset.productHandle)?'Remover dos favoritos':'Salvar nos favoritos')});
   document.querySelectorAll('[data-wishlist-count]').forEach(n=>{n.textContent=a.length;n.hidden=!a.length});
 }
 document.addEventListener('click',e=>{
   const b=e.target.closest('[data-wishlist-toggle]'); if(!b)return;
   e.preventDefault(); e.stopPropagation();
   let a=get(), h=b.dataset.productHandle, i=a.findIndex(x=>x.handle===h);
   if(i>=0)a.splice(i,1);else a.push({handle:h,title:b.dataset.productTitle,url:b.dataset.productUrl,image:b.dataset.productImage,price:b.dataset.productPrice});
   set(a);
 });
 document.addEventListener('DOMContentLoaded',sync); sync();
})();




/* Venzani 3.20 — botão do carrinho: Finalizar Compra */
document.addEventListener('DOMContentLoaded', function(){
  const cartForms = document.querySelectorAll('form[action*="/cart"]');
  cartForms.forEach(function(form){
    const buttons = form.querySelectorAll('button, input[type="submit"]');
    buttons.forEach(function(btn){
      const label = (btn.value || btn.textContent || '').trim().toLowerCase();
      if(label === 'atualizar' || label.includes('update')){
        if(btn.tagName === 'INPUT') btn.value = 'FINALIZAR COMPRA';
        else btn.textContent = 'FINALIZAR COMPRA';

        btn.setAttribute('name','checkout');
        btn.removeAttribute('value');
        btn.addEventListener('click', function(e){
          e.preventDefault();
          window.location.assign('/account/login?return_url=%2Fcheckout');
        });
      }
    });
  });
});
